'use client';

import { c as _c } from "react/compiler-runtime";
import type { CommentListInput } from '@/orpc/client';
import { useState } from 'react';
import { CommentsProvider } from '@/contexts/comments.context';
import { CommentList } from './comment-list';
import { CommentPost } from './comment-post';
type CommentSectionProps = {
  slug: string;
};
export function CommentSection(props) {
  const $ = _c(6);
  const {
    slug
  } = props;
  const [sort, setSort] = useState("newest");
  let t0;
  if ($[0] !== slug || $[1] !== sort) {
    t0 = {
      slug,
      sort,
      setSort
    };
    $[0] = slug;
    $[1] = sort;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="space-y-6"><CommentPost /><CommentList /></div>;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0) {
    t2 = <CommentsProvider value={t0}>{t1}</CommentsProvider>;
    $[4] = t0;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}